export default class SidekickAdmin {
  'id': string;
  'name': string;
  'email': string;
  'global': boolean;
  'verified': boolean;
  'createdAt': Date;
  'updatedAt': Date;
  'jobTitle': string;
  'timezone': string;
  'imageUrl': string | null;
  'lastLogin': Date;
  'passwordStrength': number;
  'mfaEnabled': boolean;
}
